module.exports = __webpack_public_path__ + "/login_ui/img/gl-95973d53e0631a1eb37dfca43eaf0b1c.svg";